import { SvgIcon, SxProps, Theme } from '@mui/material';
import { FC, isValidElement } from 'react';

export interface IconProps {
  sx?: SxProps<Theme>;
  color?: string;
  display?: boolean;
  height?: number | string;
  width?: number | string;
  strokeWidth?: number;
  onClick?: () => void;
  className?: string;
}

interface IconTemplateProps extends IconProps {
  component: FC<React.SVGProps<SVGSVGElement>>;
}

export const IconTemplate: FC<IconTemplateProps> = ({
  sx,
  color,
  display,
  height,
  width,
  strokeWidth,
  component,
  onClick,
  className
}) => {
  display = display == undefined || display == null ? true : display;
  const rendered = component.call(null, {});
  const originViewBox = isValidElement<{ viewBox?: string }>(rendered)
    ? rendered.props.viewBox
    : undefined;

  return (
    <SvgIcon
      sx={{
        ...{
          color: color ? color : 'inherit',
          display: display ? 'block' : 'none',
          height: height,
          width: width,
          '& path': {
            strokeWidth: strokeWidth
          },
          cursor: onClick ? 'pointer' : ''
        },
        ...sx
      }}
      viewBox={originViewBox}
      component={component}
      onClick={onClick}
      className={className}
    />
  );
};
